import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import injectSheet from 'react-jss';
import {
  alignmentType, responsiveImageType, SANS_SERIF, SERIF, typographyType,
} from '../../propTypes';
import theme from '../../styles/theme';
import { resolvePosition } from './container';
import Title from '../Title';
import get from '../../helpers/get';

class CaptionTitle extends Component {
  renderImage = () => {
    const {
      classes, headerImage, headerImageWidth,
    } = this.props;
    const url = get(headerImage, ['sizes', 0, 'url']);
    return (
      <div className={classes.headImageContainer}>
        <img
          className={classes.headerImage}
          src={url}
          alt={headerImage.alt}
          style={{ width: `${headerImageWidth}%`, height: `${headerImageWidth}%` }}
        />
      </div>
    );
  };

  render() {
    const {
      classes, className, title, titleTag, typography,
      headerImage,
    } = this.props;

    const classNames = cn(
      className,
      classes.title,
      {
        [classes.titleSerif]: typography === SERIF,
        [classes.titleSansSerif]: typography !== SERIF,
      },
    );

    if (headerImage) {
      return this.renderImage();
    }

    return title ? (
      <Title className={classNames} tag={titleTag}>
        {title}
      </Title>
    ) : null;
  }
}

CaptionTitle.propTypes = {
  headerImageWidth: PropTypes.number,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  headerImage: responsiveImageType,
  typography: typographyType,
  position: alignmentType, // eslint-disable-line react/no-unused-prop-types -- used in the styles
};

CaptionTitle.defaultProps = {
  headerImageWidth: 100,
  title: undefined,
  titleTag: 'h2',
  headerImage: undefined,
  className: undefined,
  typography: SANS_SERIF,
  position: undefined,
};

export default injectSheet({
  title: {
    margin: 0,
  },
  titleSansSerif: {
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    letterSpacing: 0.3,
  },
  titleSerif: {
    fontFamily: theme.fonts.heading,
    fontWeight: theme.fonts.headingWeight,
    letterSpacing: 0,
    lineHeight: 1.25,
  },
  headImageContainer: {
    display: 'flex',
    justifyContent: ({ position }) => resolvePosition(position.mobile),
    [theme.breakpoints.up('md')]: {
      justifyContent: ({ position }) => resolvePosition(position.desktop),
    },
  },
  headerImage: {
    display: 'block',
  },
})(CaptionTitle);
